import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';

import cloneDeep from 'lodash/cloneDeep';
import { registerField } from 'core/forms';
import FormFieldChips from '../components/formFieldChips';

const FormFieldChipsContainer = createReactClass({
  propTypes: {
    value: PropTypes.arrayOf(PropTypes.string),
    updateField: PropTypes.func.isRequired,
    schema: PropTypes.shape({
      isDisabled: PropTypes.bool,
    }),
    fieldId: PropTypes.string.isRequired,
  },

  getDefaultProps() {
    return {
      value: [],
      schema: {
        isDisabled: false,
      },
    };
  },

  getInitialState() {
    return {
      chips: this.props.value,
      textInputValue: '',
    };
  },

  handleUpdateTextInputValue(textValue) {
    this.setState({
      textInputValue: textValue,
    });
  },

  handleRemoveChip(chipIndex) {
    const { chips } = cloneDeep(this.state);

    chips.splice(chipIndex, 1);

    this.setState({
      chips,
    });

    this.props.updateField(chips);
  },

  handleAddNewChips(event) {
    const newChips = this.state.textInputValue.split(/[ ,]+/);
    const trimmedChips = [];
    newChips.forEach((chip) => {
      const trimmedChip = chip.replace(/ /g, '').toLowerCase();
      if (trimmedChip.length) trimmedChips.push(trimmedChip);
    });

    if (event.key === 'Enter' || event.type === 'click') {
      let { chips } = cloneDeep(this.state);
      chips = [...new Set([...chips, ...trimmedChips])];
      this.setState({
        textInputValue: '',
        chips,
      });
      this.props.updateField(chips);
    }
  },

  render() {
    const {
      schema,
      fieldId,
    } = this.props;

    return (
      <FormFieldChips
        chips={this.state.chips}
        textInputValue={this.state.textInputValue}
        isDisabled={schema.isDisabled}
        fieldId={fieldId}
        handleRemoveChip={this.handleRemoveChip}
        handleInputKeyDown={this.handleAddNewChips}
        handleAddChipsButtonClick={this.handleAddNewChips}
        handleUpdateTextInputValue={this.handleUpdateTextInputValue}
      />
    );
  },
});

registerField('Chips', React.memo(FormFieldChipsContainer));

export default FormFieldChipsContainer;
